/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Source_FileInputs */

const cs_import_source_file = /** @type {(inputs: Import_Source_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrát soubor`)
};

const en_import_source_file = /** @type {(inputs: Import_Source_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload file`)
};

/**
* | output |
* | --- |
* | "Upload file" |
*
* @param {Import_Source_FileInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_source_file = /** @type {((inputs?: Import_Source_FileInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Source_FileInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_source_file(inputs)
	return cs_import_source_file(inputs)
});